import React, { forwardRef } from "react";
import HowWeDoItSandboxedFrame from "./HowWeDoItSandboxedFrame";

/**
 * THE single renderer for a How We Do It / Tutorial document's content --
 * used identically by:
 *   - HowWeDoItEditor's live preview column (and its detached preview window,
 *     which reuses that same JSX via createPortal)
 *   - the Console's secure preview
 *   - HowWeDoItDetail, the public /how-we-do-it/:slug page
 * Given the exact same `tutorial` object, it renders the exact same thing
 * everywhere: no caller gets its own wrapper CSS, its own condition for
 * iframe-vs-light-DOM, or its own customCss-scoping logic.
 *
 * Every document uses the sandboxed frame, even when customJs is empty. This
 * keeps not-yet-saved Console HTML out of the main React document while
 * preserving one renderer for Editor Preview and the public Detail page.
 * The frame takes the height of its content (`sandboxHeight` is only the
 * height shown before the first measurement).
 */
const HowWeDoItDocumentView = forwardRef(({
  tutorial,
  sandboxHeight = 600,
  sandboxTitle = "How We Do It preview",
  linkMode = "newTab",
  minHeight,
  maxHeight,
  device,
  designer,
  selectedBlockId,
  onDesignerEvent,
}, ref) => (
  <HowWeDoItSandboxedFrame
    ref={ref}
    tutorial={tutorial}
    initialHeight={sandboxHeight}
    title={sandboxTitle}
    linkMode={linkMode}
    minHeight={minHeight}
    maxHeight={maxHeight}
    device={device}
    designer={designer}
    selectedBlockId={selectedBlockId}
    onDesignerEvent={onDesignerEvent}
  />
));

export default HowWeDoItDocumentView;
